import React from 'react';
import { SearchInput } from 'library/ui';

export function Search({
    value,
    handleChange,
}: {
    value: string;
    handleChange: (value: string | boolean, formKey: string) => void;
}) {
    return (
        <SearchInput value={value} onChange={(v) => handleChange(v, 'searchQuery')} placeholder="Search by name..." />
    );
}
